module.exports = __webpack_public_path__ + "static/Cover-mobile-d74ded79aabf539224f9c93e7b0bd225.jpg";